import React from "react";
import { Grid } from "./common/Grid";
import { GridItem } from "./common/GridItem";
import { makeStyles, tokens } from "@fluentui/react-components";
import {
  LandingPageBottomSection,
  LandingPageHeaderSection,
} from "../helper/textTemplates";
import { signExamples } from "../helper/signGeneratorHelper";
import { SignCard } from "./card/SignCard";
import { ISignGenerate } from "../interfaces/ISignGenerate";

type LandingPageProps = {
  setGenerateSign: React.Dispatch<React.SetStateAction<ISignGenerate>>;
};

const useStyles = makeStyles({
  signExampleContainer: {
    display: "flex",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "center",
      gap: tokens.spacingVerticalXXL,
    },
  },
});

export const LandingPage = ({ setGenerateSign }: LandingPageProps) => {
  const styles = useStyles();

  return (
    <Grid>
      <GridItem size="12/12">{LandingPageHeaderSection()}</GridItem>

      <GridItem size="12/12">
        <div className={styles.signExampleContainer}>
          {signExamples().map((sign, i) => (
            <SignCard sign={sign} setGenerateSign={setGenerateSign} key={i} />
          ))}
        </div>
      </GridItem>

      <GridItem size="12/12">{LandingPageBottomSection()}</GridItem>
    </Grid>
  );
};
